import * as React from 'react';
import { Typography } from 'antd';
const { Title } = Typography;
import { IProcedure } from 'common/schema/Procedure';
import { PageMainColumn } from 'client/ui/layout/page/PageMainColumn';
import { ProcedureAttachmentLink } from './ProcedureAttachmentLink';
import { useEffect, useMemo, useState } from 'react';
import { sortBy } from 'lodash';
import { ProcedureAttachmentsLogic } from 'common/schema/procedure-attachments/ProcedureAttachmentsLogic';
import { QuillHtmlRenderView } from 'client/core/html/render/QuillHtmlRenderView';
import { ProcedureLogic } from 'common/schema/ProcedureLogic';

export interface ProcedureViewMainColumnProps {
  procedure: IProcedure;
}

/**
 * Sezione della pagina di una domanda (colonna sinistra)
 * che include la descrizione della domanda per il cittadino
 *
 * Questo elemento è condiviso anche con la pagina di Anteprima lato Admin
 */
export function ProcedureViewMainColumn(props: ProcedureViewMainColumnProps) {
  const { procedure } = props;
  const orderedAttachments = useMemo(
    () =>
      sortBy(
        ProcedureAttachmentsLogic.setOrder(procedure.attachments),
        'order'
      ),
    [procedure.attachments]
  );
  const [attachmentsList, setAttachmentsList] = useState(orderedAttachments);

  useEffect(() => {
    setAttachmentsList(orderedAttachments);
  }, [procedure.attachments]);

  return (
    <PageMainColumn>
      {!procedure.hideTitleInDetailPage && (
        <Title level={1} style={{ marginBottom: '20px' }}>
          {procedure.title}
        </Title>
      )}
      <QuillHtmlRenderView content={procedure.description} />

      {!ProcedureLogic.isLawsEmpty(procedure.laws) && (
        <>
          <Title level={4}>Riferimenti Normativi</Title>
          <QuillHtmlRenderView content={procedure.laws} />
        </>
      )}
      {procedure.attachments && procedure.attachments.length > 0 && (
        <>
          <Title level={4}>Allegati</Title>
          {attachmentsList.map((attachment, i) => (
            <ProcedureAttachmentLink key={i} attachment={attachment} />
          ))}
        </>
      )}
    </PageMainColumn>
  );
}
